import React from 'react'

const Transfers = () => {
  return (
    <div>Transfers</div>
  )
}

export default Transfers